import { Routes } from '@angular/router';
import { PessoaComponent } from './modules/pessoa/pessoa.component';
import { LayoutExternoComponent } from './layout/layout-externo/layout-externo.component';
import { LayoutInscricaoPublicaComponent } from './layout/layout-inscricao-publica/layout-inscricao-publica.component';
import { InscricaoComponent } from './modules/inscricao/inscricao.component';
import { FrequenciaComponent } from './modules/frequencia/frequencia.component';
import { FrequenciaFaltasConsolidadoComponent } from './modules/frequencia/frequencia-faltas-consolidado/frequencia-faltas-consolidado.component';
import { FrequenciaMatrizComponent } from './modules/frequencia/frequencia-matriz/frequencia-matriz.component';
import { TurmaComponent } from './modules/turma/turma.component';
import { TurmaPessoaComponent } from './modules/pessoa-turma/turma-pessoa.component';
import { TurmaUsuarioComponent } from './modules/turma-usuario/turma-usuario.component';
import { ChamadasComponent } from './modules/chamadas/chamadas.component';
import { IntegracoesComponent } from './modules/integracoes/integracoes.component';
import { LoginComponent } from './modules/login/login.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { MensagensComponent } from './modules/mensagens/mensagens.component';
import { MeusDadosComponent } from './modules/meus-dados/meus-dados.component';
import { PreInscricaoComponent } from './modules/pre-inscricao/pre-inscricao.component';
import { PreInscricaoPublicaComponent } from './modules/pre-inscricao-publica/pre-inscricao-publica.component';
import { DashboardFrequenciaSemanaComponent } from './modules/dashboard/dashboard-frequencia-semana/dashboard-frequencia-semana.component';
import { MinhasTurmasComponent } from './modules/minhas-turmas/minhas-turmas.component';
import { UsuariosComponent } from './modules/usuarios/usuarios.component';
import { authChildGuard, authGuard } from './core/auth/auth.guard';
import { gestaoGuard, adminGuard, catequistaGuard } from './core/auth/role.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'inscricao',
    component: LayoutInscricaoPublicaComponent,
    children: [{ path: ':turmaId', component: InscricaoComponent }],
  },
  { path: 'inscricao-catequese/:turmaId', redirectTo: 'inscricao/:turmaId', pathMatch: 'full' },
  {
    // Link público da campanha de pré-inscrição: sem sessão, como a inscrição em turma.
    path: 'pre-inscricao',
    component: LayoutInscricaoPublicaComponent,
    children: [{ path: ':id', component: PreInscricaoPublicaComponent }],
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    component: LayoutExternoComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'frequencia-semana-anterior',
        canActivate: [gestaoGuard],
        component: DashboardFrequenciaSemanaComponent,
      },
      { path: 'pessoas', canActivate: [gestaoGuard], component: PessoaComponent },
      { path: 'turmas', canActivate: [gestaoGuard], component: TurmaComponent },
      { path: 'turma-pessoa', canActivate: [gestaoGuard], component: TurmaPessoaComponent },
      { path: 'pre-inscricoes', canActivate: [gestaoGuard], component: PreInscricaoComponent },
      // Os próprios dados: qualquer pessoa autenticada vê os seus.
      { path: 'meus-dados', component: MeusDadosComponent },
      { path: 'turma-usuario', canActivate: [gestaoGuard], component: TurmaUsuarioComponent },
      // Sem guard de perfil: o alcance é dado pelos dados — admin vê todas as turmas ativas,
      // os demais só as que têm vínculo TurmaUsuario (e só podem excluir chamadas dessas).
      { path: 'chamadas', component: ChamadasComponent },
      { path: 'frequencia/:turmaId/faltas-consolidado', component: FrequenciaFaltasConsolidadoComponent },
      { path: 'frequencia/:turmaId/matriz', component: FrequenciaMatrizComponent },
      { path: 'frequencia/:turmaId', component: FrequenciaComponent },
      { path: 'minhas-turmas', canActivate: [catequistaGuard], component: MinhasTurmasComponent },
      { path: 'usuarios', canActivate: [adminGuard], component: UsuariosComponent },
      { path: 'integracoes', canActivate: [adminGuard], component: IntegracoesComponent },
      // Corpo das mensagens tem dado pessoal: admin, e aqui o backend também confere (403).
      { path: 'mensagens', canActivate: [adminGuard], component: MensagensComponent },
    ],
  },
  { path: '**', redirectTo: '/dashboard' },
];
